import { render } from "./MessageMockItem.vue?vue&type=template&id=05a0a825&scoped=true&ts=true"
import script from "./MessageMockItem.vue?vue&type=script&lang=ts"
export * from "./MessageMockItem.vue?vue&type=script&lang=ts"

import "./MessageMockItem.vue?vue&type=style&index=0&id=05a0a825&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a0a825"]])

export default __exports__